import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import VoucherAd from '../components/voucher-ad'
import config from '../../data/siteConfig'

const CorpPage = () => (
  <span>
    <Helmet
      title={`${config.siteName} | Corporate Days | ${config.siteTitleAlt}`}
      meta={[
        {
          name: 'description',
          content: 'Get out of the office for a day and book a corporate 4x4 off roading package today to help build team work and reward your employees whilst having fun driving on our specially designed off roading courses.'
        }
      ]}
    />
    <div className="corp banner">
      <div className="banner-info top-off-center text-center">
        <h2 className="uppercase">Corporate day professional training</h2>
        <span className="spacer white hide-for-small-only">―</span>
        <h5 className="hide-for-small-only">Packages from £100 per person</h5>
        <a className="button secondary uppercase large hide-for-small-only" href="/bookings">Bookings</a>
      </div>
    </div>
    <main>
      <section className="row">
        <div className="small-12 medium-10 columns">
          <div className="content-header">
            <h1 className="uppercase">Corporate &amp; Team Building</h1>
          </div>
        </div>
      </section>
      <section className="row">
        <div className="large-9 columns">
          <div className="content-body">
            <h3 className="subheader">Build teamwork skills and reward your employees.</h3>
            <p>Our off road corporate days are a refreshing change from the everyday workplace. Whether you're entertaining special clients or looking to build rapport and break the ice with some new employees, we tailor your day to suit you and your company.</p>
            <p>A chance for some healthy competition on our specially built Trials course and some all-important communication development between team members during our Off Road games. We give your team a shared experience they'll never forget.</p>
            <p>Our off-road experience days can:</p>
            <ul>
              <li>Improve team communication</li>
              <li>Practise problem solving</li>
              <li>Encourage thinking "outside the box"</li>
              <li>Reward &amp; Motivate your employees</li>
              <li>Create a shared experience</li>
            </ul>
            <p>Corporate days can be run during normal working hours and in any weather.</p>
            <p><strong>Packages start from £100 per person.</strong></p>
          </div>
        </div>
        <aside className="large-3 columns">
          <div className="content-body">
            <VoucherAd />
          </div>
        </aside>
      </section>
    </main>
  </span>
)

export default CorpPage



// WEBPACK FOOTER //
// ./src/pages/corporate.js